/**
 * The enumeration defines possible locations for a PowerShell script.
 *
 * @see https://github.com/Microsoft/MIMWAL/blob/master/src/WorkflowActivityLibrary/Enumerations/PowerShellScriptLocation.cs
 */

export enum PowerShellScriptLocation {
  /**
   * The script is located in a file
   */
  Disk,

  /**
   * The script is located inline with the workflow xoml
   */
  WorkflowDefinition,

  /**
   * The script is located on an attribute of a FIM resource
   */
  Resource,
}
